import { responses, prReviews, type ResponseItem, type PrReview } from "@/mocks/home";
import SectionHead from "./SectionHead";

function ResponseCard({ r }: { r: ResponseItem }) {
  return (
    <div className="rounded-lg border border-background-200/70 bg-background-100/50 p-4 transition hover:bg-background-100">
      <div className="flex flex-wrap items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-500/20 text-secondary-300">
          <i className="ri-user-voice-line text-base" />
        </span>
        <div className="leading-tight">
          <div className="font-heading text-sm font-bold text-foreground-950">{r.who}</div>
          <div className="text-[11px] text-foreground-500">{r.role}</div>
        </div>
        <span className="ml-auto rounded-full bg-accent-500/15 px-2 py-0.5 text-[11px] text-accent-300">已公开</span>
      </div>
      <div className="mt-3 flex items-center gap-2 text-[11px] text-foreground-500">
        <i className="ri-file-text-line text-accent-400" />
        <span className="font-medium text-foreground-800">{r.title}</span>
        <span className="ml-auto">{r.time}</span>
      </div>
      <p className="mt-2 text-xs leading-relaxed text-foreground-600">{r.snippet}</p>
    </div>
  );
}

function PrRow({ p }: { p: PrReview }) {
  const good = p.kind === "good";
  return (
    <div className="flex gap-3 border-b border-background-200/50 py-3 last:border-0">
      <span
        className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-background-950 ${
          good ? "bg-secondary-500" : "bg-primary-500"
        }`}
      >
        <i className={`${good ? "ri-check-line" : "ri-alert-line"} text-xs`} />
      </span>
      <div>
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-semibold text-foreground-900">{p.title}</span>
          <span className={`text-[11px] ${good ? "text-secondary-300" : "text-primary-300"}`}>
            {good ? "值得借鉴" : "待改进"}
          </span>
        </div>
        <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.outcome}</p>
      </div>
    </div>
  );
}

export default function ResponsesSection() {
  return (
    <section id="response" className="border-t border-background-200/70 bg-background-100/40">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <SectionHead
          eyebrow="当事人回应与公关复盘"
          title="回应是怎么说的，公关又是怎么操作的"
          desc="左手边汇总事件中各方的公开回应口径，右手边复盘声明发布的节奏、证据呈现与传播处置，帮你看清回应背后的操作逻辑。"
        />

        <div className="mt-7 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div>
            <div className="mb-4 flex items-center gap-2">
              <i className="ri-chat-3-fill text-lg text-accent-400" />
              <h3 className="font-heading text-base font-bold text-foreground-950">当事人回应汇总</h3>
              <span className="ml-auto text-[11px] text-foreground-500">{responses.length} 方口径</span>
            </div>
            <div className="space-y-3">
              {responses.map((r) => (
                <ResponseCard key={r.who} r={r} />
              ))}
            </div>
          </div>

          <div>
            <div className="mb-4 flex items-center gap-2">
              <i className="ri-feedback-line text-lg text-secondary-400" />
              <h3 className="font-heading text-base font-bold text-foreground-950">公关操作复盘</h3>
              <span className="ml-auto text-[11px] text-foreground-500">节奏 · 证据 · 处置</span>
            </div>
            <div className="rounded-lg border border-background-200/70 bg-background-50/60 p-4">
              {prReviews.map((p) => (
                <PrRow key={p.title} p={p} />
              ))}
              <p className="mt-3 rounded-md bg-secondary-500/10 px-3 py-2 text-[11px] leading-relaxed text-secondary-300">
                复盘要点：声明解释的是「为什么」，而不是只有一句「不存在」——给得出可回溯素材的澄清，通常更能经得起后续追问。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}